import { render } from "./workbench.vue?vue&type=template&id=0cf19dce&scoped=true"
import script from "./workbench.vue?vue&type=script&lang=js"
export * from "./workbench.vue?vue&type=script&lang=js"

import "./workbench.vue?vue&type=style&index=0&id=0cf19dce&scoped=true&lang=scss"

import exportComponent from "D:\\project\\2024\\htos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf19dce"]])

export default __exports__